import { getAdditionalChargesQueryOptions } from '@/entities/facility/api/get-additional-charges.query';
import { useFacilityScope } from '@/shared/lib/hooks/use-facility-scope';
import { AdditionalChargesChart } from '@/shared/ui/charts';
import { useQuery } from '@tanstack/react-query';
import type { Dayjs } from 'dayjs';
import type { FC } from 'react';

type AdditionalChargesCardProps = {
  dateRange: {
    from: Dayjs;
    to: Dayjs;
  };
};

export const AdditionalChargesCard: FC<AdditionalChargesCardProps> = ({
  dateRange,
}) => {
  const { scopedFacilityId } = useFacilityScope();

  const { data, isLoading } = useQuery(
    getAdditionalChargesQueryOptions({
      from: dateRange.from.format('YYYY-MM-DD'),
      to: dateRange.to.format('YYYY-MM-DD'),
      facilitiesIds: scopedFacilityId ? [scopedFacilityId] : undefined,
    })
  );

  return (
    <AdditionalChargesChart
      isLoading={isLoading}
      top={data?.top ?? []}
      other={data?.other ?? []}
    />
  );
};
